import Vue from 'vue'
import { Input } from 'ant-design-vue'
import { savePreviousData } from '@/services/api'

Vue.use(Input)

export default Vue.extend({
  template: `
    <div class="a-gcell" v-if="value==='Link'" @click="openLink">
      <a style="color: #2793e6; text-decoration: underline; cursor: pointer; text-align: center;">Link</a>
    </div>
    <div v-else>
    {{value}}
    </div>
    `,

  data() {
    return {
      value: null,
      loading: false,
      editorShow: true,
      savePreviousData: savePreviousData,
    }
  },
  created() {
    this.value = this.params.data.cost_Basis && !this.params.data.link && this.params.data.sf ? 'Link' : this.params.value
  },
  methods: {
    openLink() {
      this.$root.$emit('openLinkData', this.params.data)
    },
    getValue() {
      return this.value
    },
  },
})
